import rem from 'polished/lib/helpers/rem';
import { makeStyles } from 'tss-react/mui';

export default makeStyles()(({ palette, border }) => ({
  slider: {
    width: '240px',
  },
  rail: {
    backgroundColor: palette.neutral[800],
    height: rem(4),
  },
  track: {
    height: rem(4),
  },
  thumb: {
    width: rem(24),
    height: rem(24),
    border: `1px solid ${palette.primary.main}`,
    backgroundColor: palette.common.white,
    boxShadow: 'rgb(24 24 27 / 8%) 0px 2px 8px',
  },
  inputPricesContainer: {
    display: 'flex',
    gap: rem(8),
  },
  textField: {
    backgroundColor: palette.common.white,
    borderRadius: rem(8),
    border: border[700],
    maxWidth: rem(118),
    padding: `${rem(6)} ${rem(12)}`,
  },
  textInput: {
    borderRadius: rem(8),
  },
  subtitle: {
    marginBottom: rem(8),
  },
}));
